import { createRouter, createWebHashHistory, START_LOCATION } from 'vue-router'
import store from '@/js/store/'

import Articles from '@/js/story/articles';

let routes = [
    {
      path: '/',
      name: 'Articles',
      component: Articles
    },
    {
       path: '/:pathMatch(.*)*',
      component: Articles
    },    
  ]

let router = createRouter({
  history: createWebHashHistory(),
  routes,
})


router.beforeEach((to, from) => {
  if (from === START_LOCATION) {
      if(!to.query.filter) return;

      let thema = store.getters.getFilterById(+to.query.filter);
      store.dispatch('updateFilter', {thema: thema}); 
  }
})



export default router;